import { Button } from '@factorialco/deprecated-design-system'
import { Features } from 'generated/featureDefinitions'

import { observer } from 'mobx-react'

import { useMemo } from 'modules/core/hooks/useMemo'
import i18n from 'modules/core/lib/i18n'

import ActionBox from 'modules/shift_management/components/ShiftManagement/ActionBox'
import { useEnabledFeatures } from 'modules/shift_management/hooks/useEnabledFeatures'

import { FROM, FromType } from './utils'

interface Props {
  handleChangeTab: () => void
  from: FromType
  canManageDefaultShifts?: boolean
}

const AddNewShift = ({ handleChangeTab, from, canManageDefaultShifts = false }: Props) => {
  // This will redirect old plans to the settings page to save shifts as save shift
  // toggle will not be available for them in the shift from scratch section
  const [{ canUseSaveShiftToggle: canSaveShiftsFromCustom }] = useEnabledFeatures()
  const noSavedShifts = from === FROM.NO_SHIFTS

  const title = noSavedShifts
    ? i18n.t('shift_management.actions_sidepanel.no_saved_shifts.title')
    : i18n.t('shift_management.actions_sidepanel.new_saved_shift.title')

  const noSavedShiftsDescription = canSaveShiftsFromCustom
    ? i18n.t('shift_management.actions_sidepanel.no_saved_shifts.description')
    : i18n.t('shift_management.actions_sidepanel.no_saved_shifts.description_settings')

  const createNewShiftDescription = canSaveShiftsFromCustom
    ? i18n.t('shift_management.actions_sidepanel.new_saved_shift.description')
    : i18n.t('shift_management.actions_sidepanel.new_saved_shift.description_settings')

  const description = useMemo(() => {
    if (!canManageDefaultShifts) return undefined
    if (noSavedShifts) return noSavedShiftsDescription

    return createNewShiftDescription
  }, [canManageDefaultShifts, noSavedShifts, createNewShiftDescription, noSavedShiftsDescription])

  if (!canSaveShiftsFromCustom) {
    return (
      <ActionBox
        title={title}
        description={description}
        upgradeFeature={Features.shift_management_save_shift_toggle}
      />
    )
  }

  return (
    <ActionBox
      title={title}
      description={description}
      button={
        <Button type="secondary" onClick={handleChangeTab} iconName={'add'}>
          {i18n.t('shift_management.actions_sidepanel.no_saved_shifts.button')}
        </Button>
      }
    />
  )
}

export default observer(AddNewShift)
